import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';


import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';


import Breadcrumbs from '@mui/material/Breadcrumbs';


import { green } from '@mui/material/colors';

const styles = theme => ({

    root: {
        margin: 0,
        padding: 0
    },


    buttonControl: {
        margin: '8px 0px 8px 16px'
    },


    chip: {
        margin: '8px 8px 8px 0px'
    },
    listElement: {
        margin: 10,
        padding: '4px 8px 4px 8px'
    },

    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },


    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    },

    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },


    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },

    link: theme.style.link,
    


    button: {
        margin: theme.spacing(1)
    }
});



class AdministrationFournisseur extends React.Component {
             

    render() {
        let { classes, fournisseur, isPatching, onClickSave, onChange } = this.props;

        if (!fournisseur) {
            return null;
        }

        return (
            <React.Fragment>
                

                <div className={classes.root}>

                    <Helmet>
                        <title>{`Fournisseur : ${fournisseur.code}`}</title>
                    </Helmet>

                    <Typography gutterBottom variant="h5">
                        Édition du fournisseur : {fournisseur.code} - {fournisseur.nom}
                    </Typography>


                    <Breadcrumbs separator="›" arial-label="breadcrumb">
                        <Link to={`/administration/fournisseurs/`} className={classes.link}>
                            <Typography variant="button">
                                Fournisseurs
                            </Typography>
                        </Link>

                        <Typography color="textPrimary">{fournisseur.code} - {fournisseur.nom}</Typography>
                    </Breadcrumbs>


                    <Paper className={classes.paper}>

                        <Typography gutterBottom variant="h6">
                            Paramètres
                        </Typography>
                        <FormControlLabel
                            control={
                                <Switch
                                    id="autoriseSAVPlateformeLogistique"
                                    name="autoriseSAVPlateformeLogistique"
                                    checked={fournisseur.autoriseSAVPlateformeLogistique}
                                    onChange={onChange}
                                    value="AutoriseSAVPlateformeLogistique"
                                    color="secondary"
                                />
                            }
                            label="SAV Monné autorisé : "
                            labelPlacement="start"
                        />
                        <br/>
                        <FormControlLabel
                            control={
                                <Switch
                                    id="autoriseSAV"
                                    name="autoriseSAV"
                                    checked={fournisseur.autoriseSAV}
                                    onChange={onChange}
                                    value="AutoriseSAV"
                                    color="secondary"
                                />
                            }
                            label="SAV autorisé : "
                            labelPlacement="start"
                        />
                    </Paper>



                    <Paper className={classes.paper}>

                        <Typography gutterBottom variant="h6">
                            Marques
                        </Typography>
                        <Typography gutterBottom variant="caption">
                            (note: passez par l'édition des marques pour ajouter / supprimer une marque à ce fournisseur)
                        </Typography>

                        {fournisseur.marques.map(marque => {

                            return (
                                    <p key={marque.id}>{marque.nom}</p>
                                
                                );

                        })}


                    </Paper>




                    <div className={classes.actionContainer} >

                        <Link to="/administration/fournisseurs">
                            <Button
                                className={classes.buttonControl}
                                disabled={false}
                                onClick={onClickSave}
                                variant="contained"
                                color="secondary"
                            >
                                Enregistrer
                                    {isPatching === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Button>
                        </Link>
                        <Link to="/administration/fournisseurs">
                            <Button className={classes.buttonControl} color="primary" >
                                Annuler
                            </Button>
                        </Link>
                    </div>



                </div>

            </React.Fragment>


        );
    }
}

AdministrationFournisseur.propTypes = {
    classes: PropTypes.object.isRequired,
    fournisseur: PropTypes.object
};

export default withStyles(styles)(AdministrationFournisseur);